/**
 * Created by razial on 05.08.2024.
 */

const HtmlLocalStorage = function () {
    let localStorage;
    try {
        localStorage = window.localStorage;
        localStorage.setItem("storage", "");
        localStorage.removeItem("storage");
        this.supported = true;
    } catch (e) {
        const warn = function () {
            console.warn("Warning: localStorage isn't enabled. Please confirm browser cookie or privacy option");
        };
        localStorage = {
            getItem: warn,
            setItem: warn,
            removeItem: warn,
            clear: warn
        };
        this.supported = false;
    }

    this.localStorage = localStorage;
};

connector.HtmlLocalStorage = HtmlLocalStorage; // todo tmp remove after HtmlIndexedDBStorage testing complete

HtmlLocalStorage.prototype.getItem = function (key) {
    const stored = this.localStorage.getItem(key);

    if (connector.platform.oneOf(connector.WECHAT) && stored === "") {
        return undefined;
    }

    return stored;
};

HtmlLocalStorage.prototype.setItem = function (key, value) {
    this.localStorage.setItem(key, value);
};

HtmlLocalStorage.prototype.removeItem = function (key) {
    this.localStorage.removeItem(key);
};

HtmlLocalStorage.prototype.getData = function (prefix) {
    const data = {};

    try {
        Object.keys(this.localStorage).forEach((key) => {
            if (key.indexOf(prefix) === 0) {
                data[key] = this.getItem(key);
            }
        });
    } catch (e) {
        console.error("DataLoader.getData cant read all data", e);
    }

    return data;
};

HtmlLocalStorage.prototype.clearData = function (prefix) {
    try {
        for (const storedKey in this.localStorage) {
            if (storedKey.indexOf(prefix) === 0) {
                console.log("[connector] clearing local storage key", storedKey);
                this.localStorage.removeItem(storedKey);
            }
        }
    } catch (e) {
        console.error("[connector] error clearing local storage", e);
    }
};